export default {"src":"/_next/static/media/playIcon.f612a990.svg","height":29,"width":21};